import { render, staticRenderFns } from "./RHeading.vue?vue&type=template&id=f84064e6&scoped=true"
import script from "./RHeading.vue?vue&type=script&lang=js"
export * from "./RHeading.vue?vue&type=script&lang=js"
import style0 from "./RHeading.vue?vue&type=style&index=0&id=f84064e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84064e6",
  null
  
)

export default component.exports